var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.hidden,
          expression: "!hidden"
        }
      ],
      staticClass: "input grid__cell",
      class: [_vm.inputClasses]
    },
    [
      (_vm.comOptions && _vm.comOptions.length === 0) ||
      _vm.comOptions.length > 1
        ? [
            _c(
              "div",
              {
                staticClass: "input--select",
                attrs: { disabled: _vm.disabled }
              },
              [
                _c("input", {
                  ref: _vm.name,
                  staticClass: "input__el",
                  attrs: { name: _vm.name, type: "checkbox", isSelect: "" },
                  on: {
                    focus: function($event) {
                      ;[
                        _vm.dropdownToTop(),
                        _vm.handleFocus(),
                        _vm.ableKeyNav()
                      ]
                    },
                    blur: function($event) {
                      ;[_vm.handleFocus()]
                    },
                    keydown: [
                      function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "down", 40, $event.key, [
                            "Down",
                            "ArrowDown"
                          ])
                        ) {
                          return null
                        }
                        return _vm.keyNavDown($event)
                      },
                      function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "up", 38, $event.key, [
                            "Up",
                            "ArrowUp"
                          ])
                        ) {
                          return null
                        }
                        return _vm.keyNavUp($event)
                      },
                      function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.updateValueOnEnter($event)
                      }
                    ]
                  }
                }),
                _c("div", { staticClass: "inputOverLay" }),
                _c("p", { staticClass: "text-small blueDark mg mg--b-2" }, [
                  _vm._v(_vm._s(_vm.$t(_vm.literal)))
                ]),
                _c("transition", { attrs: { name: "dropdown" } }, [
                  _c(
                    "ul",
                    {
                      staticClass: "input--select__dropdown",
                      class: [{ upward: _vm.dropdownUpward }]
                    },
                    _vm._l(_vm.comOptions, function(option) {
                      return _c(
                        "li",
                        {
                          class: { focus: _vm.isFocus(option.key) },
                          attrs: { value: option.key },
                          on: {
                            click: function($event) {
                              return _vm.selectOption(option)
                            }
                          }
                        },
                        [
                          _c("label", [
                            _c("p", { staticClass: "text-medium black" }, [
                              _vm._v(_vm._s(option.literal))
                            ])
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ]),
                _c("div", { staticClass: "input--select__visible" }, [
                  _c("p", { staticClass: "text-medium black" }, [
                    _vm._v(_vm._s(_vm.selectedLiteral))
                  ]),
                  _c(
                    "span",
                    { staticClass: "input__arrow" },
                    [
                      _c("svgicon", {
                        attrs: { icon: "arrow_dropdown", height: "12" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "span",
                    { staticClass: "input__icon" },
                    [
                      _c("svgicon", {
                        attrs: {
                          icon: _vm.icon,
                          height: "18",
                          color: "#FFFFFF"
                        }
                      })
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ]
        : [
            _c("div", { staticClass: "input--text" }, [
              _c("p", { staticClass: "text-small blueDark mg mg--b-2" }, [
                _vm._v(_vm._s(_vm.$t(_vm.literal)))
              ]),
              _c("div", { staticClass: "input__wrapper" }, [
                _c("input", {
                  attrs: { name: _vm.name, type: "text", disabled: "" },
                  domProps: { value: _vm.selectedLiteral }
                }),
                _c(
                  "span",
                  { staticClass: "input__icon" },
                  [
                    _c("svgicon", {
                      attrs: { icon: _vm.icon, height: "18", color: "#FFFFFF" }
                    })
                  ],
                  1
                )
              ])
            ])
          ],
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.alertIsVisible,
              expression: "alertIsVisible"
            }
          ],
          staticClass: "input__alerts"
        },
        [
          _c(
            "div",
            { staticClass: "input__icon" },
            [_c("svgicon", { attrs: { name: "alert-circle" } })],
            1
          ),
          _c("div", { staticClass: "input__alerts__wrapper" }, [
            _c(
              "div",
              _vm._l(_vm.validationErrors, function(error) {
                return _c("p", { staticClass: "input__alerts__text" }, [
                  _vm._v(_vm._s(error.description))
                ])
              }),
              0
            )
          ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }